import clsx from "clsx"

type Props = {
  value?: number | null
  expanded?: boolean
}

export const SidebarBadge = ({ value, expanded }: Props) => {
  const n = Number(value ?? 0)
  if (!Number.isFinite(n) || n <= 0) return null

  return (
    <div
      className={clsx(
        "flex items-center min-w-[18px] h-[18px] justify-center rounded-full bg-red px-1 text-[11px] font-semibold text-white",
        "transition-opacity duration-200 ease-in-out",
        expanded ? "opacity-0" : "opacity-100"
      )}
      aria-label={`${n}`}
      title={`${n}`}
    >
      <span>{n > 99 ? "99+" : n}</span>
    </div>
  )
}
